module.exports = __webpack_public_path__ + "static/img/img1.c697ce53.png";